export default "__VITE_ASSET__kfmrp0OF__"